<!-- 新增企业提醒 -->
<template>
  <div id="addCustomer">
    <a-form-model :model="saveForm" ref="ruleForm" :colon="false" >
      <div class="customerFormDiv">
        <a-row :gutter="20">
          <!-- 时间 -->
          <a-col :span="12">
            <a-form-model-item :label="$t('customer.remindDetail.time')" prop="startTime" class="required"
                               :rules=" [ {required: true,message: $t('customer.remindDetail.dateTip'),},]" >
              <a-date-picker v-model:value="saveForm.startTime" @change="onChange" :allowClear="false" :disabled-date="disabledDate" style="width: 100%" :format="dateFormat"
                             :placeholder="$t('customer.remindDetail.selectTip')" />
            </a-form-model-item>
          </a-col>
          <!-- 工作提醒 -->
          <a-col :span="12">
            <a-form-model-item :label="$t('customer.remindDetail.workRemind')" prop="advanceDays" class="required"
                               :rules=" [ {required: true,message: $t('customer.remindDetail.workTip'),},]" >
              <pt-select v-model="saveForm.advanceDays" :placeholder="$t('customer.remindDetail.selectTip')" style="width: 100%">
                <a-select-option
                  v-for="item in workList"
                  :key="item.value"
                  :value="item.value"
                  :disabled="isWorkItemDisabled(item)">
                  {{ item.label }}
                </a-select-option>
              </pt-select>
            </a-form-model-item>
          </a-col>
          <!-- 备注 -->
          <a-col :span="24">
            <a-form-model-item prop="content" :label="$t('customer.remindDetail.theme')" class="required"
                               :rules=" [ {required: true,message: $t('customer.remindDetail.themeTip'),},]">
              <a-textarea  :rows="4" v-model="saveForm.content" :placeholder="$t('key82qingshuru')"  :maxLength="200"></a-textarea>
            </a-form-model-item>
          </a-col>
        </a-row>
      </div>
    </a-form-model>
  </div>
</template>
<script >
import moment from 'moment'

export default {
  name: 'addCustomerRemind',

  props: {
    customerId: null,
  },
  data() {
    return {
      saveForm: {
        businessId: this.customerId,
        accountIds:[this.$store.getters.userInfo.accountDO.id],
        remindType: 27,
        content: undefined,
        startTime: moment().add(1, 'days'),
        advanceDays: undefined,
      },
      workList: [
        {
          value: 0,
          label: this.$t('customer.remindDetail.workRemindList.thatDay'),
        },
        {
          value: 1,
          label: this.$t('customer.remindDetail.workRemindList.beforeOneDay'),
        },
        {
          value: 2,
          label: this.$t('customer.remindDetail.workRemindList.beforeTwoDay'),
        },
        {
          value: 3,
          label: this.$t('customer.remindDetail.workRemindList.beforeThreeDay'),
        },
        {
          value: 7,
          label: this.$t('customer.remindDetail.workRemindList.beforeOneWeek'),
        }
      ],
      dateFormat: 'YYYY-MM-DD',
    }
  },
  computed: {
    // 计算选择日期与今天日期的差值（只比较年月日）
    dateDiffDays() {
      if (!this.saveForm.startTime) {
        return 0;
      }
      // 计算选择日期与今天日期的差值（只比较年月日）
      const selectedDate = moment(this.saveForm.startTime).startOf('day');
      const today = moment().startOf('day');
      return selectedDate.diff(today, 'days');
    }
  },
  methods: {
    disabledDate(current) {
      return current && current < moment().endOf('day');
    },
    onChange(value, dateString) {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
      this.saveForm.startTime = moment(value).startOf('day')
      this.saveForm.advanceDays = undefined
    },
    // 判断工作提醒选项是否应该被禁用
    isWorkItemDisabled(item) {
      // 如果没有选择日期，则不禁用任何选项
      if (!this.saveForm.startTime) {
        return false;
      }

      // 计算提醒时间 = 选择日期 - 提前天数
      // 提醒时间不能早于明天（即提醒时间必须 >= 明天）
      // 选择日期 - 提前天数 >= 明天
      // dateDiffDays - item.value >= 1
      // item.value <= dateDiffDays - 1

      return item.value > this.dateDiffDays - 1;
    },
    getData(){
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            console.log('saveForm::::',this.saveForm)
            resolve(this.saveForm)
          }else{
            this.$message.warning("请正确输入表单")
            reject()
          }
        })
      })
    }
  },
}
</script>
<style scoped lang="less">
</style>
